import React from "react";
import {
  Box,
  IconButton,
  styled,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  DoNotDisturb as ClosedIcon,
  LockOpen as OpenIcon,
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
} from "@mui/icons-material";

const StyledTab = styled(Tab)(() => ({
  fontSize: "0.9rem",
  minHeight: 48,
  fontWeight: 500,
  "&.Mui-selected": {
    fontWeight: 600,
  },
}));

interface WorksTabsProps {
  tabValue: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  viewType: "card" | "list";
  onViewTypeChange: (viewType: "card" | "list") => void;
}

const WorksTabs: React.FC<WorksTabsProps> = ({
  tabValue,
  onTabChange,
  viewType,
  onViewTypeChange,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <Tabs
        value={tabValue}
        onChange={onTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          flex: 1,
          "& .MuiTabs-flexContainer": {
            borderBottom: 1,
            borderColor: "divider",
          },
        }}
      >
        <StyledTab
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <OpenIcon fontSize="small" sx={{ mr: 1 }} />
              Öppna
            </Box>
          }
          value="open"
        />
        <StyledTab
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ClosedIcon fontSize="small" sx={{ mr: 1 }} />
              Stängda
            </Box>
          }
          value="closed"
        />
        <StyledTab
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />
              Lösta
            </Box>
          }
          value="solved"
        />
      </Tabs>

      <Box
        sx={{
          ml: 2,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          p: 0.5,
        }}
      >
        <Tooltip title="Kortvy">
          <IconButton
            size="small"
            color={viewType === "card" ? "primary" : "default"}
            onClick={() => onViewTypeChange("card")}
            sx={{ borderRadius: 1 }}
          >
            <ViewModuleIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Listvy">
          <IconButton
            size="small"
            color={viewType === "list" ? "primary" : "default"}
            onClick={() => onViewTypeChange("list")}
            sx={{ borderRadius: 1 }}
          >
            <ViewListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default WorksTabs;
